import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import Card from "../../../Card";
import Table from "../../../Table";
import Widget from "../../../../Utility/Crud/Widget";
import MainContext from "../../../../Context/MainContext/MainContext";

export default function CardAdminWidgetList() {
    const context = useContext(MainContext);
    const history = useHistory();

    const renderContent = () => {
        return (
            <Table
                search={true}
                columns={[
                    { key: "id", name: "ID", type: "number" },
                    { key: "name", name: "Name", type: "string", width: 260 },
                    { key: "widgetComponentTermId", name: "Component", type: "term" },
                ]}
                rows={Widget.sort(Object.values(context.widgetsIndexed))}
                onClick={(widget) => {
                    history.push(`/admin/widget/${widget.id}`);
                }}
            />
        );
    };

    return (
        <Card
            renderContent={renderContent}
            getTitle={() => null}
        />
    );
}
